import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ReviewCard from "@/components/feature/ReviewCard";
import Seo from "@/components/feature/Seo";
import BackToTop from "@/components/feature/BackToTop";
import { reviewSites, reviewDimensions } from "@/mocks/reviews";

const featured = reviewSites.filter((s) => s.badge && s.badge !== "避雷警示");
const others = reviewSites.filter((s) => !s.badge || s.badge === "避雷警示");

const faqs = [
  {
    q: "哪个漫画网站好用？",
    a: "没有绝对最好，关键看你的需求。追求广告少、加载快，漫阅阁、追番屋是不错的选择；追国漫韩漫推荐漫语源；想看老作品可以试试漫米堂；追求界面体验则看漫画卷。",
  },
  {
    q: "漫画网站广告多不多？",
    a: "差别很大。良心站（如漫阅阁、漫画卷）广告很克制，几乎不打扰阅读；而像「漫画针」这类站点广告极多、弹窗频繁，需要谨慎避雷。我们每个评测都有独立的广告控制评分。",
  },
  {
    q: "漫画网站加载速度怎么看？",
    a: "主要看图片是否走 CDN 分发、页面是否轻量。漫阅阁、追番屋、快漫台在加载速度上表现出色，连播翻页基本不用等待。",
  },
  {
    q: "如何判断一个漫画网站是否良心？",
    a: "看四点：广告是否克制、是否免费、有无套路诱导下载或付费、界面是否友好。我们把这四项综合为「良心程度」评分，方便你快速判断。",
  },
  {
    q: "使用漫画网站要注意什么？",
    a: "优先选择广告少、无诱导套路的站点，避免点击来路不明的弹窗；同时尊重版权，尽量支持正版。我们的避雷指南里有更详细的建议。",
  },
];

const heroStats = [
  { value: "8+", label: "站点评测" },
  { value: "4", label: "评测维度" },
  { value: "100%", label: "客观参考" },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        data={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebSite",
              name: "漫界指南",
              url: "https://kmniy25.cn/",
              description: "漫画网站推荐与避雷评测平台，从广告控制、加载速度、内容收录与良心程度帮你筛选良心站。",
            },
            {
              "@type": "FAQPage",
              mainEntity: faqs.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            },
          ],
        }}
      />
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=expressive%20anime%20manga%20style%20artwork%20with%20young%20reader%20diving%20into%20a%20world%20of%20floating%20comic%20pages%20and%20story%20bubbles%2C%20warm%20coral%20red%2C%20cream%20and%20teal%20palette%2C%20dynamic%20flat%20illustration%2C%20soft%20depth%20and%20motion%2C%20no%20text%2C%20noise%20grain%20texture&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
            alt="漫画网站推荐与避雷评测的首屏背景图"
            title="漫画网站推荐 避雷评测"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/60 to-background-950/80"></div>

          <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
            <span className="rounded-full bg-secondary-400/20 px-4 py-1.5 text-xs font-medium text-secondary-100 ring-1 ring-secondary-300/30">
              漫画网站推荐 · 避雷指南 · 良心站筛选
            </span>
            <h1 className="mt-6 max-w-3xl font-display text-3xl leading-snug text-background-50 md:text-5xl">
              漫画网站哪个好用？
              <br />
              <span className="text-secondary-200">少踩坑，看漫画更省心</span>
            </h1>
            <p className="mt-6 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base">
              我们实地体验上百个漫画网站，从广告多不多、加载速度快不快、内容是否齐全到是否良心，
              用真实评测帮你筛出靠谱的站点，从此告别弹窗轰炸和套路诱导。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/rankings"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-trophy-line"></i>
                查看综合榜单
              </Link>
              <Link
                to="/guide"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-medium text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/25"
              >
                <i className="ri-shield-check-line"></i>
                避雷指南
              </Link>
            </div>

            <div className="mt-12 flex flex-wrap items-center justify-center gap-8">
              {heroStats.map((s) => (
                <div key={s.label} className="text-center">
                  <p className="font-display text-2xl text-secondary-200 md:text-3xl">{s.value}</p>
                  <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 编辑力荐 */}
        <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
            <div>
              <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">编辑力荐 · 良心站</h2>
              <p className="mt-2 text-sm text-foreground-600">广告克制、加载流畅、体验友好，闭眼入不踩坑的选择</p>
            </div>
            <Link to="/rankings" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
              全部榜单 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {featured.map((site) => (
              <ReviewCard key={site.slug} site={site} />
            ))}
          </div>
        </section>

        {/* 避雷警示 banner */}
        <section className="bg-foreground-950">
          <div className="mx-auto flex w-full max-w-7xl flex-col items-start gap-6 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-6">
            <div className="flex items-start gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-red-500 text-background-50">
                <i className="ri-alert-line text-2xl"></i>
              </span>
              <div>
                <h2 className="font-display text-xl text-background-50 md:text-2xl">避雷提醒：这些站点要绕开</h2>
                <p className="mt-2 max-w-2xl text-sm leading-6 text-background-200">
                  广告多、弹窗频繁、诱导下载与付费套路的站点，我们统一标记为「避雷警示」。看漫画省心，先学会避开这些坑。
                </p>
              </div>
            </div>
            <Link
              to="/guide"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-red-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-red-600"
            >
              <i className="ri-shield-flash-line"></i>
              查看避雷要点
            </Link>
          </div>
        </section>

        {/* 更多评测 */}
        <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
          <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">更多评测</h2>
          <p className="mt-2 text-sm text-foreground-600">覆盖综合、专题、老牌与新人类站点，横向对比更全面</p>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {others.map((site) => (
              <ReviewCard key={site.slug} site={site} />
            ))}
          </div>
        </section>

        {/* 评测维度 */}
        <section className="border-y border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
            <div className="max-w-2xl">
              <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">我们的评测维度</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                我们不只看表面的资源多少，更关注真实的阅读体验。每个站点都从四个维度给出独立评分。
              </p>
            </div>
            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {reviewDimensions.map((d, i) => (
                <div key={d.key} className="rounded-xl border border-background-200 bg-background-50 p-5">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-lg text-lg ${i === 0 ? "bg-primary-100 text-primary-700" : i === 1 ? "bg-accent-100 text-accent-700" : i === 2 ? "bg-secondary-100 text-secondary-900" : "bg-background-200 text-foreground-800"}`}>
                    {i === 0 ? <i className="ri-advertisement-line"></i> : i === 1 ? <i className="ri-speed-line"></i> : i === 2 ? <i className="ri-book-2-line"></i> : <i className="ri-heart-line"></i>}
                  </span>
                  <h3 className="mt-4 font-display text-lg text-foreground-950">{d.label}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{d.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                关于漫画网站怎么选、广告怎么看、速度怎么判断的疑问，这里一次性说清楚。
              </p>
              <Link
                to="/about"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="lg:col-span-3">
              <div className="space-y-3">
                {faqs.map((f) => (
                  <details key={f.q} className="group rounded-xl border border-background-200 bg-background-50 px-5 py-4">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-medium text-foreground-950">
                      {f.q}
                      <i className="ri-add-line text-secondary-600 transition-transform group-open:rotate-45"></i>
                    </summary>
                    <p className="mt-3 text-sm leading-6 text-foreground-600">{f.a}</p>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}